module.exports = __webpack_public_path__ + "static/media/pic_winie2_02.8ebe3eb5.png";